export default "__VITE_ASSET__CxYH5Per__"